import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { OwnerDocument, PropertyAcquisitionDocument, PropertyOwnershipDocument } from '@usucampeao/lib-reurb-simplificado';
import { NavigationService } from '../../services';
import { ModalDocumentoOutroComponent } from '../modal-documento-outro/modal-documento-outro.component';

@Component({
  selector: 'usucampeao-documentos-selecionar-tipo',
  templateUrl: './documentos-selecionar-tipo.component.html',
  styleUrls: ['./documentos-selecionar-tipo.component.scss']
})
export class DocumentosSelecionarTipoComponent {
  @Input() documentosAquisicao: PropertyAcquisitionDocument[];
  @Input() documentosPosse: PropertyOwnershipDocument[];
  @Input() documentosIdentidade: OwnerDocument[];
  @Input() documentosEstadoCivil: OwnerDocument[];

  constructor(
    private modalCtrl: ModalController,
    private navigation: NavigationService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  public get possuiDocumentoAquisicao(): boolean {
    return this.documentosAquisicao?.length > 0;
  }

  public get possuiDocumentoPosse(): boolean {
    return this.documentosPosse?.length > 0;
  }

  public get possuiDocumentoIdentidade(): boolean {
    return this.documentosIdentidade?.length > 0;
  }

  public get possuiDocumentoEstadoCivil(): boolean {
    return this.documentosEstadoCivil?.length > 0;
  }

  public selecionarDocumento(documentoTipo: string): void {
    if (documentoTipo === PropertyAcquisitionDocument.OTHERS) {
      this.abrirModalDocumentoOutro(documentoTipo);
    } else {
      this.iaParaUploadDocumento(documentoTipo);
    }
  }

  private async abrirModalDocumentoOutro(documentoTipo: string): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: ModalDocumentoOutroComponent,
      cssClass: 'modal-documento-outro'
    });

    modal.present();
    const { data } = await modal.onWillDismiss();

    if (data) {
      this.iaParaUploadDocumento(documentoTipo, data.nome);
    }
  }

  private iaParaUploadDocumento(tipo: string, nome?: string): void {
    this.router.navigate(['../upload'], {
      relativeTo: this.route,
      queryParams: { tipo, nome },
      replaceUrl: true
    });
  }

  public cancelar(): void {
    this.navigation.voltar();
  }
}
